import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

type SubMenus = "LIST_OF_CALLS" | "TRADES_LIST" | "BIDDER_POOL" | "EMAIL_TEMPLATES";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config = [];
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "TENDER_MODERN")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;

    if (subModules) {
      subModules.includes("LIST_OF_CALLS") &&
        config.push({
          label: <MenuItemWithBadge label={`List of calls`} />,
          link: "list",
        });
      subModules.includes("TRADES_LIST") &&
        config.push({
          label: <MenuItemWithBadge label={`Trades list`} />,
          link: "trades-pool",
        });
      subModules.includes("BIDDER_POOL") &&
        config.push({
          label: <MenuItemWithBadge label={`Bidder pool`} />,
          link: "bidder-pool",
        });
      subModules.includes("EMAIL_TEMPLATES") &&
        config.push({
          label: <MenuItemWithBadge label={`Email templates`} />,
          link: "email-templates",
        });
    }

    return config;
  },
};
